import { AccrualSuggestionBucket } from "@common/types/accrualSuggestionBucket";
import { TransactionStatus } from "@common/types/transaction";
import {
    ACCRUAL_REVIEW_VIEW_OPTIONS,
    columnsForBucket,
} from "@common/types/views/accrualReviewView";
import { ViewType } from "@common/types/views/views";
import { accrualReviewCloseTemplateViewConfigSchema } from "@common/schemas/close-template-task-view-config.schema";

export function createAccrualReviewViewConfig(bucket: AccrualSuggestionBucket) {
    return accrualReviewCloseTemplateViewConfigSchema.parse({
        type: ViewType.TRANSACTION,
        columns: columnsForBucket(bucket),
        options: ACCRUAL_REVIEW_VIEW_OPTIONS,
        filters: {
            isNotAccrualReviewed: true,
            statuses: [TransactionStatus.COMPLETED],
            accrualSuggestionBuckets: [bucket],
        },
    });
}
